<template>
  <div class="theme-football-effects" v-if="$activeTheme.id === 'football'">
    <span class="football-light football-light-left"></span>
    <span class="football-light football-light-right"></span>
    <span class="football-particle"></span>
    <span class="football-particle"></span>
    <span class="football-particle"></span>
    <span class="football-particle"></span>
    <span class="football-particle"></span>
    <span class="football-particle"></span>
    <span class="football-particle"></span>
    <span class="football-particle"></span>
    <span class="football-particle"></span>
    <span class="football-particle"></span>
    <span class="football-particle"></span>
    <span class="football-particle"></span>
    <span class="football-particle"></span>
    <span class="football-particle"></span>
    <!-- <span class="football-rolling-ball"></span> -->
  </div>
</template>

<script>
export default {
  name: "ThemeFootballEffects"
};
</script>
